import React from 'react'
import Element from '../../components/element';
import GradientDivider from '../../components/gradientDivider';
import { ReactComponent as LogoSVG } from '../../assets/icons/ThorneHealthLogo.svg';


const ContactUs = () => {

    const attrs = {
        width: '80%',
        margin: 'auto',
        backgroundColor: 'white',
        padding: '40px'
    };
    // const classes = useStyles()

    return (
        <Element {...attrs}>

            <Element type={LogoSVG} width="25%" />
            <GradientDivider />
            <Element fontFamily="GTAM" fontSize="21px"
                marginBottom="15px">
                Contact Us
            </Element>
            <Element fontFamily="GTAR" fontSize="14px">
                If you have any queries please email us at <strong>thornelabs4help@thorne.com</strong>
            </Element>
        </Element >

    )
}

export default ContactUs




